import { DxpError } from '../../../core/error/dxp-error';

export class ClipboardUnavailableError extends DxpError {
  readonly code = 'CLIPBOARD_UNAVAILABLE';

  constructor() {
    super('The clipboard API is not available or was denied by the browser.');
  }
}
